import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getCreditNotes: function ({filterByDate, limit, page = '1', sort, filterByClient, filterByConsumed}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, sort]
    if (filterByDate) query.push(filterByDate)
    if (filterByClient) query.push(filterByClient)
    if (filterByConsumed) query.push(filterByConsumed)
    return instCred.get('creditnotes?' + query.join('&'))
  },
  createCreditNotes: function (credit) {
    credit.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('creditnotes', credit)
  },
  editCreditNotes: function (credit) {
    credit.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('creditnotes/' + credit.id, credit)
  },
  deleteCreditNotes: function (idCredit) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('creditnotes/' + idCredit)
  },
  getCreditNotesConsumed: function (clientId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`client=${clientId}`]
    return instCred.get('creditnotes/notconsumed?' + query.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/CreditNotes/api.js